$(function() {
  // Delegated so swatches in cards rendered after load (filtering, pagination) still work.
  $(document).on('mouseenter mouseleave', '.product-swatch-inline__image', function() {
    var productId = $(this).data('id');
    if (!productId) return;

    var productBlock = $(this).closest('.product-block');
    // Scope to this card. The images live inside it, and hiding every sibling node
    // would also hide the quick buy button, which never comes back.
    var imageElement = productBlock.find('.product-block__image[data-id="' + productId + '"]');
    if (imageElement.length === 0) return;

    var titleLink = productBlock.find('.product-block__title-link');
    titleLink.attr('href', imageElement.attr('href'));
    productBlock.find('.product-block__image').not(imageElement).hide();
    imageElement.show();
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.querySelector('.toggle-button');
  const additionalContent = document.querySelector('.additional-content');

  if (toggleButton) {
    toggleButton.addEventListener('click', function() {
      if (additionalContent.style.display === 'none' || additionalContent.style.display === '') {
        additionalContent.style.display = 'block';
        toggleButton.textContent = 'Learn More -';
      } else {
        additionalContent.style.display = 'none';
        toggleButton.textContent = 'Learn More +';
      }
    });
  }
});